import React, { memo, useEffect, useMemo, useRef, useState } from "react"
import {ClipLoader} from 'react-spinners'
import n0 from './wingoimg/0.svg'
import n1 from './wingoimg/1.svg'
import n2 from './wingoimg/2.svg'
import n3 from './wingoimg/3.svg'
import n4 from './wingoimg/4.svg'
import n5 from './wingoimg/5.svg'
import n6 from './wingoimg/6.svg'
import n7 from './wingoimg/7.svg' 
import n8 from './wingoimg/8.svg'
import n9 from './wingoimg/9.svg'


import n0_flat from './wingoimg/0_flat.svg'
import n1_flat from './wingoimg/1_flat.svg'
import n2_flat from './wingoimg/2_flat.svg'
import n3_flat from './wingoimg/3_flat.svg'
import n4_flat from './wingoimg/4_flat.svg'
import n5_flat from './wingoimg/5_flat.svg'
import n6_flat from './wingoimg/6_flat.svg'
import n7_flat from './wingoimg/7_flat.svg' 
import n8_flat from './wingoimg/8_flat.svg'
import n9_flat from './wingoimg/9_flat.svg'


import n0_gray from './wingoimg/0_gray.svg'
import n1_gray from './wingoimg/1_gray.svg'
import n2_gray from './wingoimg/2_gray.svg'
import n3_gray from './wingoimg/3_gray.svg'
import n4_gray from './wingoimg/4_gray.svg'
import n5_gray from './wingoimg/5_gray.svg'
import n6_gray from './wingoimg/6_gray.svg'
import n7_gray from './wingoimg/7_gray.svg' 
import n8_gray from './wingoimg/8_gray.svg'
import n9_gray from './wingoimg/9_gray.svg'


import b1 from './k3img/b1.svg'
import b2 from './k3img/b2.svg'
import b3 from './k3img/b3.svg'
import b4 from './k3img/b4.svg'
import b5 from './k3img/b5.svg'
import b6 from './k3img/b6.svg'
import b_empty from './k3img/b_empty.svg' 
import FlipNumbers from "react-flip-numbers"

import m1 from './motorimg/motor_round_1.svg'
import m2 from './motorimg/motor_round_2.svg'
import m3 from './motorimg/motor_round_3.svg'
import m4 from './motorimg/motor_round_4.svg'
import m5 from './motorimg/motor_round_5.svg'
import m6 from './motorimg/motor_round_6.svg'
import m7 from './motorimg/motor_round_7.svg'
import m8 from './motorimg/motor_round_8.svg'
import m9 from './motorimg/motor_round_9.svg'
import m10 from './motorimg/motor_round_10.svg'

import _ from 'lodash'
import { Spin } from "antd"
import { useCurrentGame } from "../../hooks/useDraw"
import theme from "../../theme"
import _5d_ball_bg from './5dimg/5d_ball_bg.svg'
import first_num_bg from './wingoimg/first_num_bg.svg'
import { index } from "cheerio/dist/commonjs/api/traversing"
import Spacer from "../../components/Spacer"


export const useK3Pics:()=>string[] = ()=>{
    const lotteryPics = useMemo(()=>{
        return [b_empty,b1,b2,b3,b4,b5,b6];
    },[]);
    return lotteryPics;
}
export const useWingoPics:()=>string[] = ()=>{
    const lotteryPics = useMemo(()=>{
        return [n0,n1,n2,n3,n4,n5,n6,n7,n8,n9];
    },[]);
    return lotteryPics;
}


export const useMotorPics:()=>string[] = ()=>{
    const lotteryPics = useMemo(()=>{
        return [null,m1,m2,m3,m4,m5,m6,m7,m8,m9,m10];
    },[]);
    return lotteryPics;
}

export const useWingoFlatPics:()=>string[] = ()=>{
    const lotteryPics = useMemo(()=>{
        return [n0_flat,n1_flat,n2_flat,n3_flat,n4_flat,n5_flat,n6_flat,n7_flat,n8_flat,n9_flat];
    },[]);
    return lotteryPics;
}

export const useWingoGrayPics:()=>string[] = ()=>{
    const lotteryGrayPics = useMemo(()=>{
        return [n0_gray,n1_gray,n2_gray,n3_gray,n4_gray,n5_gray,n6_gray,n7_gray,n8_gray,n9_gray];
    },[]);
    return lotteryGrayPics
}
export const WinGoDrawAnim:React.FC<{drawResult:any}> = ({drawResult})=>{
    
    const lotteryGrayPics = useWingoGrayPics()
    const lotteryPics = useWingoPics()
    return <div style={{display:'flex',width:'100%',justifyContent:'center',flexDirection:'row'}}>{
        // @ts-ignore
        drawResult?.content?.premium.split('').map((item:any,index:number)=>{
            // item = 0
            return <div style={{width:'12%',marginRight:'3%',marginLeft:'3%',objectFit:'contain',position:'relative'}} >
                <img alt='' src={index==0?lotteryPics[parseInt(item)]:lotteryGrayPics[parseInt(item)]} style={{width:'100%'}} />
                {index==0 && <img src={first_num_bg} style={{position:'absolute',left:'-10%',right:0,bottom:'-40%',width:'120%'}}/>}
                {index==0 && <div style={{position:'absolute',left:'-10%',right:0,top:'-50%',width:'200%',fontSize:12,}}>Last result</div>}
            </div>
        })
    }</div>
}

export const K3DrawAnim:React.FC<{drawResult:any}> = ({drawResult})=>{
    const lotteryPicsBig = useMemo(()=>{
        return [b1,b2,b3,b4,b5,b6];
      },[])
    const sum = useMemo(()=>{
        return drawResult?.content?.premium.split('').map((i:string)=>parseInt(i)).reduce((pv:number,cv:number,ci:number)=>pv+cv,0)
    },[drawResult])
    return <div style={{flexDirection:'row',display:'flex',alignItems:'center',flex:1,justifyContent:'center',color:'gray',fontWeight:'bold'}}>{
        // @ts-ignore
        drawResult?.content?.premium.split('').map((item,index,arr)=>{
            console.log('premium',item)
            return <>
                <img src={lotteryPicsBig[parseInt(item)-1]} alt={item+''} title={item} style={{width:'10%',marginLeft:'2%',marginRight:'2%',objectFit:'contain'}} />
                {index!= arr.length-1 && '+'}
                {/* {item} */}
            </>
          })}
        =<div style={{width:'10%',position:'relative',marginLeft:'2%',marginRight:'2%',}}>
            <img src={b_empty} style={{width:'100%', objectFit:'contain'}} />
            <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,alignItems:'center',justifyContent:'center',display:'flex',fontSize:25,color:'white'}}>
                {sum}
            </div>
        </div>
        
    </div>
}

export const _5DDrawAnim:React.FC<{drawResult:any,loading:boolean}> = ({drawResult,loading=false})=>{
    useEffect(()=>{
        if(loading){
            return
        }
        function getNextVal(digit:string){
            const val = parseInt(digit)
            if(val===0){
              return 9
            }else{
              return val - 1
            }
          }
          if(intervalRef.current){
            clearInterval(intervalRef.current)
          }
          // numberRef.current = numberRef.current
          intervalRef.current = setInterval(()=>{
            const nextValue = numberRef.current.split('').map(d=>getNextVal(d)).join('')
            numberRef.current = nextValue 
            setNumbers(numberRef.current+'')
          },100)
    },[loading])
    useEffect(()=>{
        // 触发开奖历史更新
        
        // loadMore(true)
        if(intervalRef.current){
            clearInterval(intervalRef.current)
        }
        // @ts-ignore
        const result = drawResult?.content.premium||'00000'
        setNumbers(result)
        numberRef.current = result
    },[drawResult])

    const [numbers,setNumbers] = useState<string>('')
    const numberRef = useRef<string>('73464')
    const intervalRef = useRef<NodeJS.Timeout>()
    const sum = useMemo(()=>{
        return numbers.split('').map((i:string)=>parseInt(i)).reduce((pv:number,cv:number,ci:number)=>pv+cv,0)
    },[numbers])
    return <div style={{display:'flex',paddingLeft:10,paddingRight:10}}>
        <div style={{borderRadius:5,overflow:'hidden',flexDirection:'row',display:'flex',alignItems:'center',color:'gray',justifyContent:'center'}}>
            {/* <FlipNumbers height={40} width={30} numberStyle={{fontSize:18}} color="#e6393b" background="white" play perspective={100} numbers={numbers} /> */}
            {numbers.split('').map((num,index,arr)=><>
                <_5dBall num={parseInt(num)} position={String.fromCharCode(65+index)}/>
                {index != arr.length-1 && <div style={{marginLeft:5,marginRight:5,marginBottom:25}}>+</div>}
            </>)}
            <div style={{marginLeft:5,marginRight:5,marginBottom:25}}>=</div><_5dBall num={sum} position=''/>
        </div>
    </div>
} 

export const _5dBall:React.FC<{num:number,position:string,width?:string,fontSize?:string}> = ({num,position='A',width,fontSize})=>{
    return <div style={{width:width || '12%',position:'relative'}}>
            <div style={{position:'relative',}}>
                <img src={_5d_ball_bg} style={{width:'100%'}}/>
                <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,alignItems:'center',justifyContent:'center',display:'flex',fontSize: fontSize || 15,fontWeight:'bold',color:'black'}}>{num}</div>
            </div>
            <div style={{textAlign:'center',color:'black',height:25}}>{position}</div>
        </div>
}

export const TrxWingoAnim:React.FC<{drawResult:any}> = ({drawResult})=>{
    const lotteryPics = useMemo(()=>{
        return [n0,n1,n2,n3,n4,n5,n6,n7,n8,n9];
    },[]);
    return <div style={{display:'flex',width:'100%',justifyContent:'center'}}>{
            // @ts-ignore
        (drawResult?.content?.blockID||'').substring(59,64).split('').map((item:string,index:number,arr:string[])=>{
                let isRightMostNumber = true
                // @ts-ignore
                if(!isNaN(item)){
                // 扫描右边的数字
                for(let i = index+1;i<arr.length;i++){
                    // @ts-ignore
                    if(!isNaN(arr[i])){
                    isRightMostNumber = false
                    break;
                    }
                }
                }else{
                    isRightMostNumber = false
                }
                // console.log('isRightMostNumber',item,index,arr,isRightMostNumber)
                if(isRightMostNumber){
                    return <img src={lotteryPics[parseInt(item)]} alt='' style={{width:'15%',marginRight:'2%',marginLeft:'2%',objectFit:'contain'}} />
                }else{  
                    return <div style={{width:'15%',display:'flex',color:'gray',marginRight:'2%',marginLeft:'2%',alignItems:'center',justifyContent:'center',position:'relative',fontWeight:'bold'}} >
                        <div style={{borderStyle:'solid',color:'gray',borderWidth:1,borderRadius:100,position:'absolute',left:0,top:0,bottom:0,right:0}}/>
                        <div style={{textAlign:'center'}}>{item.toUpperCase()}</div>
                    </div>
                }
            
            // return item
        })}
    </div>
} 

const LotteryDrawAnim:React.FC<{drawResult:any}> = ({drawResult})=>{
    const game = useCurrentGame()
      if(!game){
        return <></>
      }
      if(!drawResult || (drawResult && drawResult.lottery.toLowerCase() !== game)){
          return <ClipLoader color={theme.color.primary.main} size={30} />
      }
      // if(!drawResult){
      //   return <ClipLoader color={theme.color.primary.main} size={30} />
      // }
      if(game === 'wingo'){
        return <WinGoDrawAnim drawResult={drawResult}/>
      }
      if(game === 'k3'){
        return <K3DrawAnim drawResult={drawResult}/>
      }
      if(game === '5d'){
        // @ts-ignore
        return <_5DDrawAnim drawResult={drawResult}/>
      }
      if(game === 'trxwingo'){
        return <TrxWingoAnim drawResult={drawResult}/>
      }
}

export default LotteryDrawAnim;